import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classes from "./form.module.css"
import InputField from "../../../containers/inputField/inputField";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Form = (props) => {
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [withInvitation, setWithInvitation] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    
    // Get language from Redux props instead of localStorage
    const currentLang = props.selectedLanguage;
    const isEnglish = currentLang === 1;
    
    const [controls, setControls] = useState({
        kidName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Enter name" : "أدخل الاسم",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Kid's Full Name" : "الاسم الكامل للطفل",
            valid: false,
            touched: false
        },
        dateOfBirth: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: isEnglish ? "Select date" : "اختر التاريخ",
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Date Of Birth" : "تاريخ الميلاد",
            valid: false,
            touched: false
        },
        guestNumber: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: isEnglish ? "Enter number" : "أدخل العدد",
                min: "1",
            },
            value: "",
            validation: {
                required: true,
                isNumeric: true
            },
            label: isEnglish ? "Guests Number" : "عدد الضيوف",
            valid: false,
            touched: false
        },
        availablePartyDate: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: isEnglish ? "Select date" : "اختر التاريخ",
            },
            availableDates: props.availableSlots,
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Preferred Birthday Date" : "تاريخ عيد الميلاد المفضل",
            valid: false,
            touched: false
        },
        time: {
            elementType: "select",
            elementConfig: {
                type: "text",
                placeholder: isEnglish ? "Select time" : "اختر الوقت",
                options: []
            },
            value: "",
            validation: {
                required: true,
            },
            label: isEnglish ? "Preferred Time" : "الوقت المفضل",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: isEnglish ? "Enter email" : "أدخل البريد الإلكتروني",
            },
            value: "",
            label: isEnglish ? "Email" : "البريد الإلكتروني",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true,
                minLength: 10,
                maxLength: 10
            },
            label: isEnglish ? "Phone" : "رقم الهاتف",
            valid: false,
            touched: false
        },
        specialRequests: {
            elementType: "textarea",
            elementConfig: {
                type: "textarea",
                placeholder: isEnglish ? "Enter your requests in details" : "أدخل طلباتك بالتفصيل",
            },
            value: "",
            label: isEnglish ? "Special Requests" : "طلبات خاصة",
            valid: false,
            touched: false,
        },
    });
    
    // Update form controls when language changes
    useEffect(() => {
        const updatedControls = { ...controls };
        
        // Update each control's language-specific properties
        Object.keys(updatedControls).forEach(key => {
            const control = updatedControls[key];
            
            // Update placeholder and label based on language
            if (control.elementConfig) {
                if (key === 'kidName') {
                    control.elementConfig.placeholder = isEnglish ? "Enter name" : "أدخل الاسم";
                    control.label = isEnglish ? "Kid's Full Name" : "الاسم الكامل للطفل";
                } else if (key === 'dateOfBirth') {
                    control.elementConfig.placeholder = isEnglish ? "Select date" : "اختر التاريخ";
                    control.label = isEnglish ? "Date Of Birth" : "تاريخ الميلاد";
                } else if (key === 'guestNumber') {
                    control.elementConfig.placeholder = isEnglish ? "Enter number" : "أدخل العدد";
                    control.label = isEnglish ? "Guests Number" : "عدد الضيوف";
                } else if (key === 'availablePartyDate') {
                    control.elementConfig.placeholder = isEnglish ? "Select date" : "اختر التاريخ";
                    control.label = isEnglish ? "Preferred Birthday Date" : "تاريخ عيد الميلاد المفضل";
                } else if (key === 'time') {
                    control.elementConfig.placeholder = isEnglish ? "Select time" : "اختر الوقت";
                    control.label = isEnglish ? "Preferred Time" : "الوقت المفضل";
                } else if (key === 'email') {
                    control.elementConfig.placeholder = isEnglish ? "Enter email" : "أدخل البريد الإلكتروني";
                    control.label = isEnglish ? "Email" : "البريد الإلكتروني";
                } else if (key === 'phone') {
                    control.label = isEnglish ? "Phone" : "رقم الهاتف";
                } else if (key === 'specialRequests') {
                    control.elementConfig.placeholder = isEnglish ? "Enter your requests in details" : "أدخل طلباتك بالتفصيل";
                    control.label = isEnglish ? "Special Requests" : "طلبات خاصة";
                }
            }
        });
        
        setControls(updatedControls);
    }, [props.selectedLanguage]);

    useEffect(() => {
        const updatedControls = {
            ...controls,
            availablePartyDate: {
                ...controls.availablePartyDate,
                availableDates: props.availableSlots
            }
        };
        setControls(updatedControls);
    }, [props.availableSlots]);

    useEffect(() => {
        controls.availablePartyDate.value.length > 0 && handleDateSelection(controls.availablePartyDate.value)
    }, [controls.availablePartyDate.value]);

    const formElementsArray = [];
    for (let key in controls) {
        formElementsArray.push({
            id: key,
            config: controls[key]
        });
    }
    const form = formElementsArray.map((formElement, i) => (
        <div key={i} className={[classes.FormGroup, formElement.id === "availablePartyDate" && classes.FormGroupCalendar].join(" ")}>
            <InputField
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                availableDates={formElement.config.availableDates}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                withRemove={false}
                withIcon={formElement.config.withIcon}
                label={formElement.config.label}
                changed={event => inputChangedHandler(event, formElement.id)}
            />
        </div>
    ));
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.minLength) {
            isValid = value?.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value?.length <= rules.maxLength && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    });
    // Handle date selection
    const handleDateSelection = (selectedDate) => {        
        const selectedSlots = props.availableSlots.find(
            (slot) => slot.date === selectedDate[0]
        );

        // Update time options
        const updatedOptions = selectedSlots
            ? selectedSlots.slots.map((slot) => ({
                value: slot.time,
                displayValue: slot.time,
            }))
            : [];
        const updatedControls = {
            ...controls,
            time: {
                ...controls.time,
                elementConfig: {
                    ...controls.time.elementConfig,
                    options: updatedOptions
                }
            }
        };
        setControls(updatedControls);
    };

    const inputChangedHandler = (event, controlName) => {
        const value = (controlName === 'phone' || controlName === 'dateOfBirth' || controlName === 'availablePartyDate') ? event : event.target.value;
        const updatedControls = {
            ...controls,
            [controlName]: {
                ...controls[controlName],
                value,
                valid: checkValidity(value, controls[controlName].validation),
                touched: true
            }
        };
        setControls(updatedControls);
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        if (!props.isAuthenticated) props.setShowLoginForm(true)
        else {
            setError(null);
            setLoading(true);
            try {
                // Include language in API request if needed
                const formData = {
                    type_id: 1,
                    selected_activities: props.selectedActivities,
                    food_items: props.selectedFood,
                    equipment_rentals: props.selectedDecoration?.length > 0 && [{
                        equipment_id: props.selectedDecoration[0],
                        quantity: 1
                    }],
                    invitation_card: withInvitation,
                    date: controls.availablePartyDate.value[0],
                    time_slot: controls.time.value,
                    kid_name: controls.kidName.value,
                    date_of_birth: controls.dateOfBirth.value,
                    participants_count: controls.guestNumber.value,
                    contact_details: {
                        email: controls.email.value,
                        phone: controls.phone.value.dialCode + controls.phone.value.number,
                        name: controls.kidName.value
                    },
                    special_requests: controls.specialRequests.value,
                    event_details: "Birthday Party",
                    lang: props.selectedLanguage // Add language to API request if needed
                };
                
                // Use language param in API call if your API needs it
                const response = await sixYardAxios.post('/activities/book', formData);
                
                if (response.data) {
                    localStorage.setItem("BirthdayBooking", JSON.stringify(formData));
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    props.setBirthdayRegistrationId(response.data.data.registration_id);
                    props.setBirthdayPaymentData(response.data.data);
                    props.setBirthdayBookingDate({
                        date: controls.availablePartyDate.value[0],
                        time_slot: controls.time.value
                    })
                    setMessage(response.data.data.message || "Your order was submitted successfully. We will reach you soon");
                }
            } catch (err) {
                setError(err.response?.data?.message || 'Something went wrong. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    };
    const successClicked = () => {
        setMessage(false);
        window.location.reload();
    }
    return (
        <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setWithInvitation(!withInvitation)} />
                <label className={classes.Label}>
                    {isEnglish 
                        ? "Add customized invitation cards"
                        : "إضافة بطاقات دعوة مخصصة"}
                </label>
            </div>
            {form}
            <p className={classes.Prompt}>
                {isEnglish 
                    ? "Please read and agree to our "
                    : "يرجى قراءة والموافقة على "}
                <a href="/privacy-policy" target='_blank' className={classes.Link}>
                    {isEnglish 
                        ? "Privacy Policy "
                        : "سياسة الخصوصية "}
                </a>
                {isEnglish ? "and " : "و "}
                <a href="/terms-and-conditions" target='_blank' className={classes.Link}>
                    {isEnglish ? "Terms" : "الشروط"}
                </a>
            </p>
            <div className={classes.CheckBox}>
                <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                <label className={classes.Label}>
                    {isEnglish 
                        ? "I have read and agreed to terms and conditions and privacy policy"
                        : "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية"}
                </label>
            </div>

            <div>
                <button
                    type="submit"
                    className={[
                        classes.submitButton,
                        (!isTermsChecked || loading) && classes.Disabled
                    ].join(" ")}
                    disabled={!isTermsChecked || loading}
                >
                    {loading 
                        ? (isEnglish ? 'PROCESSING...' : 'جاري المعالجة...') 
                        : (isEnglish ? 'SUBMIT' : 'إرسال')}
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                        alt=""
                        className={classes.submitIcon}
                    />
                </button>
            </div>
            {message && <PromptMessage 
                successMessage 
                message={message} 
                status={isEnglish ? 'CONGRATULATIONS' : 'تهانينا'} 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={successClicked} 
            />}
            {error && <PromptMessage 
                message={error} 
                status={isEnglish ? 'Oops' : 'عفواً'} 
                button={isEnglish ? 'CLOSE' : 'إغلاق'} 
                click={() => setError(false)} 
            />}
        </form>
    );
};

const mapStateToProps = state => ({
    selectedLanguage: state.home.selected_language
});

export default connect(mapStateToProps)(Form);
